// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Project chat tab. Scoped under .project-chats (commons/Chats has its own .chat-* classes). */

/* Fills the visible area under the tabs; the message list scrolls and the composer stays put. */
.project-chats {
  display: flex;
  width: 100%;
  height: clamp(420px, calc(100dvh - var(--ds-topbar-h) - 220px), 900px);
  min-height: 0;
}

.project-chats .project-chats__main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/commons/Projects/ProjectChats/ProjectChats.css"],"names":[],"mappings":"AAAA,+FAA+F;;AAE/F,gGAAgG;AAChG;EACE,aAAa;EACb,WAAW;EACX,sEAAsE;EACtE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,gBAAgB;AAClB","sourcesContent":["/* Project chat tab. Scoped under .project-chats (commons/Chats has its own .chat-* classes). */\n\n/* Fills the visible area under the tabs; the message list scrolls and the composer stays put. */\n.project-chats {\n  display: flex;\n  width: 100%;\n  height: clamp(420px, calc(100dvh - var(--ds-topbar-h) - 220px), 900px);\n  min-height: 0;\n}\n\n.project-chats .project-chats__main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
